<span class="subtitle">
  (descending order | time zone based on browser location | click a row for details)
</span>
<p class="margin-left" *ngIf="(logItems$ | async).length < 1">
  Trip actions will appear here.
</p>
<div class="log-grid">
  <div
    class="log-row"
    *ngFor="let logItem of logItems$ | async"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="isExpanded(logItem)"
    [class.expanded]="isExpanded(logItem)"
    (click)="toggleExpanded(logItem)"
    (keydown.enter)="toggleExpanded(logItem)"
    (keydown.space)="$event.preventDefault(); toggleExpanded(logItem)"
  >
    <span class="log-status">
      @if (isImOkayEntry(logItem)) {
        <img
          class="log-status-icon"
          [src]="getLogStatusIcon(logItem)"
          [alt]="logItem.status + ' status'"
          [title]="logItem.status"
        />
        <span class="log-status-text">{{ logItem.status }}</span>
      } @else {
        <span class="status-chip {{ statusPillClass(logItem.status) }}">{{
          logItem.status
        }}</span>
      }
    </span>
    <span class="log-by">
      @if (logItem.recordedByName) {
        {{ abbreviateName(logItem.recordedByName) }}
      } @else {
        <span class="deleted-user">Deleted user</span>
      }
    </span>
    <span class="log-date">{{ compactDate(logItem.datetime) }}</span>
    <span class="log-time">{{ compactTime(logItem.datetime) }}</span>

    <div
      class="log-detail"
      *ngIf="isExpanded(logItem)"
      (click)="$event.stopPropagation()"
      (keydown.enter)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
    >
      <div class="log-detail-desc">{{ logItem.description }}</div>
      <div class="log-detail-note" *ngIf="logItem.note">
        Note: {{ logItem.note }}
      </div>
      <div class="log-detail-by">
        @if (logItem.recordedByName) {
          Recorded by {{ logItem.recordedByName
          }}<ng-container *ngIf="logItem.recordedByRole"
            >, {{ logItem.recordedByRole }}</ng-container
          >
          at
        } @else {
          Recorded by <span class="deleted-user">Deleted user</span> at
        }
        {{ compactTime(logItem.recordedByDatetime) }}
        {{ compactDate(logItem.recordedByDatetime) }}
      </div>
    </div>
  </div>
</div>
